import notificationsApi from './api';
import subscriptionsApi from '../subscriptions/sagas/api';
import subscriptionsToasts from '../subscriptions/sagas/toasts';
import subscribersApi from '../subscribers/sagas/api';
import announcementsApi from '../announcements/sagas/api';
import announcementsLayout from '../announcements/sagas/layout';

export default [
  notificationsApi(),
  subscriptionsApi(),
  subscriptionsToasts(),
  subscribersApi(),
  announcementsApi(),
  announcementsLayout(),
];
